export const URL_PATH = {
  projectDetail: 'rs/project/:projectId',
  comment: 'comment',
  workflow: 'workflow',
  master: 'master-table',
  tenantManager: 'tenant-manager',
} as const;
